import { render, staticRenderFns } from "./AttachmentTable.vue?vue&type=template&id=0ea57c78&"
import script from "./AttachmentTable.vue?vue&type=script&lang=js&"
export * from "./AttachmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports